<template>
  <div id="OrderStatusSelfService">
    <Spinner v-if="isLoading" />
    <div>
      <img
        class="image"
        src="../assets/Feed_logo.png"
        height="75%" 
        width="75%"
      />

      <h3><strong>Resumen de la compra:</strong></h3>

      <article v-if="qrUrl !== null">
        <img :src="qrUrl" />
      </article>

      <p><strong>Cantidad disponible:</strong> {{ availableQuantity }}</p>

      <p><strong>Cantidad consumida:</strong> {{ usedQuantity }}</p>

      <article v-if="consumptionTimeStamps.length > 0">
        <p><strong>Detalle de consumos:</strong></p>
        <ul v-for="(item, index) in consumptionTimeStamps" :key="index">
          <li>{{ item }}</li>
        </ul>
      </article>
    </div>
  </div>
</template>
<script>
import Spinner from "../Components/Spinner";
import { http } from "../axios";
import { baseUrl } from "../server";
import QRCode from "qrcode";

export default {
  data() {
    return {
      code: null,
      data: null,
      isLoading: true,
      qrUrl: null,
      availableQuantity: 0,
      usedQuantity: 0,
      consumptionTimeStamps: [],
    };
  },
  mounted() {
    this.code = this.$route.query.c;

    http
      .get(`${baseUrl}/api/OrderStatusSelfService?Code=${this.code}`)
      .then((response) => {
        if (response.data.responseCode === 0) {
          this.generateQrCode(response.data.qrFilePath);
          this.availableQuantity = response.data.availableQuantity;
          this.usedQuantity = response.data.usedQuantity;
          this.consumptionTimeStamps = response.data.consumptionTimeStamps;

          this.isLoading = false;
        } else {
          this.$router.push("Failure");
        }
      })
      .catch((error) => {
        console.log(error);
        this.$router.push("Failure");
      });
  },
  computed: {},
  methods: {
    generateQrCode(qrFilePath) {
      QRCode.toDataURL(qrFilePath)
        .then((url) => {
          console.log(url);
          this.qrUrl = url;
          // this.downloadQr(this.getQrUrl);
        })
        .catch((err) => {
          console.error(err);
        });
    },
    // downloadQr(qrUrl) {
    //   var download = document.createElement("a");
    //   download.href = qrUrl;
    //   download.download = `Qr-${this.external_ref}.jpg`;
    //   download.click();
    // },
  },
  components: {
    Spinner,
  },
};
</script>
<style scoped>
#OrderStatusSelfService {
  height: 40em;
  padding-bottom: 100vh;
}
.image {
  height: 500;
  width: 500;
  padding-bottom: 5vh;
}
#OrderStatusSelfService div {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%, -50%);
}
</style>



// WEBPACK FOOTER //
// src/pages/OrderStatusSelfService.vue